import React from "react";

const STEPS = ["Carrito", "Fecha", "Datos", "Direc.", "Vend.", "Pago"];

function StepperBar({ step }) {
    return (
        <div className="bg-[#fdf7ef] border-b border-[#e8ddd2] px-4 pt-2.5 pb-2">
            <div className="flex items-start max-w-sm mx-auto">
                {STEPS.map((label, i) => {
                    const num = i + 1;
                    const isDone    = num < step;
                    const isCurrent = num === step;

                    return (
                        <React.Fragment key={num}>
                            {/* Círculo + label */}
                            <div className="flex flex-col items-center flex-shrink-0">
                                <div className={`w-5 h-5 rounded-full flex items-center justify-center ${
                                    isDone || isCurrent ? "bg-[#f5853f]" : "bg-[#ddd5c8]"
                                }`}>
                                    {isDone ? (
                                        <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    ) : (
                                        <span className={`text-[8px] font-bold leading-none ${isCurrent ? "text-white" : "text-[#a89a86]"}`}>
                                            {num}
                                        </span>
                                    )}
                                </div>
                                <span
                                    className={`text-[8px] font-medium mt-0.5 text-center leading-tight ${
                                        isDone || isCurrent ? "text-[#c4682a]" : "text-[#b8a898]"
                                    }`}
                                    style={{ width: "36px" }}
                                >
                                    {label}
                                </span>
                            </div>

                            {/* Línea conectora */}
                            {i < STEPS.length - 1 && (
                                <div className={`flex-1 h-[2px] mt-[9px] mx-0.5 rounded-full ${
                                    isDone ? "bg-[#f5853f]" : "bg-[#ddd5c8]"
                                }`} />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}

export default StepperBar;
